import type { ReactNode } from 'react'
import type { Control } from 'react-hook-form'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'

import type { InviteMemberFormSchemaType } from './members.schema'

interface InviteMemberEmailFieldProps {
  control: Control<InviteMemberFormSchemaType>
  isDisabled?: boolean
}

export const InviteMemberEmailField: React.FC<InviteMemberEmailFieldProps> = ({
  control,
  isDisabled = false,
}): ReactNode => (
  <FormField
    control={control}
    name="email"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Email Address</FormLabel>
        <FormControl>
          <Input
            {...field}
            type="email"
            placeholder="colleague@example.com"
            disabled={isDisabled}
            className="invite-member-email-input"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
)

InviteMemberEmailField.displayName = 'InviteMemberEmailField'
